const mockStopPressure = {
  "articles": [],
  "organizations": [],
  "charts": [{
    "charts": [{
      "title": "Надійшло повідомлень",
      "primaryValue": 176,
      "subtitle": {
        "type": "insight",
        "delta": "9%",
        "trend": "up",
        "text": ""
      }
    }, {
      "title": "Розглянуто повідомлень",
      "primaryValue": 168,
      "subtitle": {
        "type": "insight",
        "delta": "20%",
        "trend": "down",
        "text": ""
      }
    }]
  }, {
    "charts": [{
      "title": "Середній строк розгляду",
      "primaryValue": 11,
      "subtitle": {
        "type": "insight",
        "text": "днів"
      }
    }, {
      "title": "Проведено особистий прийом заявників",
      "primaryValue": 29,
      "subtitle": {
        "type": "insight",
        "delta": "20%",
        "trend": "down",
        "text": ""
      }
    }]
  }, {
    "charts": [{
      "type": "line-chart",
      "title": "Динаміка надходження повідомлень",
      "subtitle": null,
      "primaryValue": 150,
      "data": {
        "minY": 135,
        "maxY": 210,
        "sets": [{
          "label": "Отримано повідомлень",
          "details": "",
          "maxPointPrecision": "month",
          "lineStyle": "#42B0FF",
          "fillStyle": {
            "stops": [{
              "color": "#42B0FF99",
              "position": 0
            }, {
              "color": "#42B0FF00",
              "position": 1
            }]
          },
          "points": [{
            "x": "2025-02-01",
            "y": 186,
            "delta": "15%",
            "trend": "up"
          }, {
            "x": "2025-03-01",
            "y": 176,
            "delta": "5%",
            "trend": "down"
          }, {
            "x": "2025-04-01",
            "y": 198,
            "delta": "12%",
            "trend": "up"
          }, {
            "x": "2025-05-01",
            "y": 170,
            "delta": "14%",
            "trend": "down"
          }, {
            "x": "2025-06-01",
            "y": 199,
            "delta": "17%",
            "trend": "up"
          }, {
            "x": "2025-07-01",
            "y": 195,
            "delta": "2%",
            "trend": "down"
          }, {
            "x": "2025-08-01",
            "y": 195,
            "delta": "",
            "trend": ""
          }, {
            "x": "2025-09-01",
            "y": 174,
            "delta": "10%",
            "trend": "down"
          }, {
            "x": "2025-10-01",
            "y": 176,
            "delta": "1%",
            "trend": "up"
          }, {
            "x": "2025-11-01",
            "y": 155,
            "delta": "11%",
            "trend": "down"
          }, {
            "x": "2025-12-01",
            "y": 160,
            "delta": "3%",
            "trend": "up"
          }, {
            "x": "2026-01-01",
            "y": 150,
            "delta": "6%",
            "trend": "down"
          }]
        }, {
          "label": "Розглянуто повідомлень",
          "details": "",
          "maxPointPrecision": "month",
          "lineStyle": "#FFDE65",
          "fillStyle": {
            "stops": [{
              "color": "#FFDE6599",
              "position": 0
            }, {
              "color": "#FFDE6500",
              "position": 1
            }]
          },
          "points": [{
            "x": "2025-02-01",
            "y": 172,
            "delta": "18%",
            "trend": "up"
          }, {
            "x": "2025-03-01",
            "y": 175,
            "delta": "1%",
            "trend": "up"
          }, {
            "x": "2025-04-01",
            "y": 178,
            "delta": "1%",
            "trend": "up"
          }, {
            "x": "2025-05-01",
            "y": 157,
            "delta": "11%",
            "trend": "down"
          }, {
            "x": "2025-06-01",
            "y": 188,
            "delta": "19%",
            "trend": "up"
          }, {
            "x": "2025-07-01",
            "y": 179,
            "delta": "4%",
            "trend": "down"
          }, {
            "x": "2025-08-01",
            "y": 195,
            "delta": "8%",
            "trend": "up"
          }, {
            "x": "2025-09-01",
            "y": 159,
            "delta": "18%",
            "trend": "down"
          }, {
            "x": "2025-10-01",
            "y": 166,
            "delta": "4%",
            "trend": "up"
          }, {
            "x": "2025-11-01",
            "y": 146,
            "delta": "12%",
            "trend": "down"
          }, {
            "x": "2025-12-01",
            "y": 145,
            "delta": "0%",
            "trend": "down"
          }, {
            "x": "2026-01-01",
            "y": 135,
            "delta": "6%",
            "trend": "down"
          }]
        }]
      }
    }]
  }, {
    "charts": [{
      "type": "pie-chart",
      "title": "Вжиті заходи реагування",
      "data": {
        "sets": [{
          "label": "Повернуто вилучене майно",
          "value": 41,
          "color": "#1BDE93"
        }, {
          "label": "Вжито заходи прокурорського реагування",
          "value": 20,
          "color": "#F89678"
        }, {
          "label": "Скасовано незаконних рішень",
          "value": 15,
          "color": "#5245DF"
        }, {
          "label": "Внесені відомості до ЄРДР",
          "value": 13,
          "color": "#42B0FF"
        }, {
          "label": "Закрито кримінальних проваджень",
          "value": 11,
          "color": "#FFDE65"
        }]
      }
    }]
  }, {
    "charts": [{
      "type": "line-chart",
      "title": "Повернуто вилучені грошові кошти",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Гривні",
          "details": "Details",
          "fillStyle": "#19DE92",
          "points": [{
            "y": 1571610,
            "yFormatted": "1 571 610 ₴",
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }]
        }, {
          "label": "Долари США",
          "details": "Details",
          "fillStyle": "#FFDE65",
          "points": [{
            "y": 322075,
            "yFormatted": "322 075 $",
            "x": "2023-01-01",
            "delta": "5%",
            "trend": "down"
          }]
        }, {
          "label": "Євро",
          "details": "Details",
          "fillStyle": "#42B0FF",
          "points": [{
            "y": 316115,
            "yFormatted": "316 115 €",
            "x": "2023-01-01",
            "delta": "34%",
            "trend": "up"
          }]
        }]
      }
    }, {
      "type": "line-chart",
      "title": "Повернуто вилучене майно",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Транспортні засоби та техніка",
          "details": "Details",
          "fillStyle": "#19DE92",
          "points": [{
            "y": 1,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }]
        }, {
          "label": "Обладнання",
          "details": "Details",
          "fillStyle": "#FFDE65",
          "points": [{
            "y": 2,
            "x": "2023-01-01",
            "delta": "5%",
            "trend": "down"
          }]
        }, {
          "label": "Комп'ютерна техніка та електронні пристрої",
          "details": "Details",
          "fillStyle": "#42B0FF",
          "points": [{
            "y": 30,
            "x": "2023-01-01",
            "delta": "34%",
            "trend": "up"
          }]
        }]
      }
    }]
  }, {
    "charts": [{
      "type": "ukraine-map",
      "title": "Надходження повідомлень по регіонам",
      "data": {
        "sets": [{
          "id": "primary",
          "label": "Офіс Генерального прокурора",
          "value": 1231,
          "color": "#FFDE65"
        }, {
          "id": "kyiv",
          "label": "м. Київ",
          "value": 144,
          "color": "#F4A582",
          "opacity": 1
        }, {
          "id": "kyiv-oblast",
          "label": "Київська область",
          "value": 78,
          "color": "#F4A582",
          "opacity": 0.6676258992805755
        }, {
          "id": "vinnytsia-oblast",
          "label": "Вінницька область",
          "value": 44,
          "color": "#FFDE65",
          "opacity": 0.4964028776978417
        }, {
          "id": "volyn-oblast",
          "label": "Волинська область",
          "value": 44,
          "color": "#FFDE65",
          "opacity": 0.4964028776978417
        }, {
          "id": "dnipropetrovsk-oblast",
          "label": "Дніпропетровська область",
          "value": 45,
          "color": "#F4A582",
          "opacity": 0.5014388489208633
        }, {
          "id": "donetsk-oblast",
          "label": "Донецька область",
          "value": 41,
          "color": "#FFDE65",
          "opacity": 0.481294964028777
        }, {
          "id": "zhytomyr-oblast",
          "label": "Житомирська область",
          "value": 54,
          "color": "#F4A582",
          "opacity": 0.5467625899280575
        }, {
          "id": "zakarpattia-oblast",
          "label": "Закарпатська область",
          "value": 45,
          "color": "#FFDE65",
          "opacity": 0.5014388489208633
        }, {
          "id": "zaporizhzhia-oblast",
          "label": "Запорізька область",
          "value": 49,
          "color": "#F4A582",
          "opacity": 0.5215827338129496
        }, {
          "id": "ivano-frankivsk-oblast",
          "label": "Івано-Франківська область",
          "value": 16,
          "color": "#7FC97F",
          "opacity": 0.3553956834532374
        }, {
          "id": "kirovohrad-oblast",
          "label": "Кіровоградська область",
          "value": 45,
          "color": "#FFDE65",
          "opacity": 0.5014388489208633
        }, {
          "id": "luhansk-oblast",
          "label": "Луганська область",
          "value": 16,
          "color": "#7FC97F",
          "opacity": 0.3553956834532374
        }, {
          "id": "lviv-oblast",
          "label": "Львівська область",
          "value": 67,
          "color": "#F4A582",
          "opacity": 0.612230215827338
        }, {
          "id": "mykolaiv-oblast",
          "label": "Миколаївська область",
          "value": 59,
          "color": "#F4A582",
          "opacity": 0.5719424460431655
        }, {
          "id": "odesa-oblast",
          "label": "Одеська область",
          "value": 101,
          "color": "#F4A582",
          "opacity": 0.7834532374100718
        }, {
          "id": "poltava-oblast",
          "label": "Полтавська область",
          "value": 45,
          "color": "#FFDE65",
          "opacity": 0.5014388489208633
        }, {
          "id": "rivne-oblast",
          "label": "Рівненська область",
          "value": 15,
          "color": "#7FC97F",
          "opacity": 0.35035971223021584
        }, {
          "id": "sumy-oblast",
          "label": "Сумська область",
          "value": 32,
          "color": "#FFDE65",
          "opacity": 0.4359712230215827
        }, {
          "id": "ternopil-oblast",
          "label": "Тернопільська область",
          "value": 20,
          "color": "#7FC97F",
          "opacity": 0.37553956834532376
        }, {
          "id": "kharkiv-oblast",
          "label": "Харківська область",
          "value": 56,
          "color": "#F4A582",
          "opacity": 0.5568345323741006
        }, {
          "id": "kherson-oblast",
          "label": "Херсонська область",
          "value": 8,
          "color": "#7FC97F",
          "opacity": 0.3151079136690647
        }, {
          "id": "khmelnytskyi-oblast",
          "label": "Хмельницька область",
          "value": 21,
          "color": "#7FC97F",
          "opacity": 0.38057553956834533
        }, {
          "id": "cherkasy-oblast",
          "label": "Черкаська область",
          "value": 41,
          "color": "#FFDE65",
          "opacity": 0.481294964028777
        }, {
          "id": "chernivtsi-oblast",
          "label": "Чернівецька область",
          "value": 45,
          "color": "#FFDE65",
          "opacity": 0.5014388489208633
        }, {
          "id": "chernihiv-oblast",
          "label": "Чернігівська область",
          "value": 7,
          "color": "#7FC97F",
          "opacity": 0.31007194244604314
        }, {
          "id": "crimea-union",
          "label": "АР Крим",
          "value": 5,
          "color": "#7FC97F",
          "opacity": 0.3
        }]
      }
    }]
  }]
};
export { mockStopPressure };